(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["site-loader"] && !Shopify.designMode) return;
  try {
    (() => {
    const loader = document.querySelector('[data-site-loader]');
    if (!loader) return;

    let finished = false;
    const finish = () => {
      if (finished) return;
      finished = true;
      loader.classList.add('is-done');
      window.RUGSONE_INTRO_COMPLETE = true;
      document.dispatchEvent(new CustomEvent('rugsone:intro-complete'));
      window.setTimeout(() => loader.remove(), 1100);
    };

    const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 100 : 1250;
    if (document.readyState === 'complete') {
      window.setTimeout(finish, delay);
    } else {
      window.addEventListener('load', () => window.setTimeout(finish, delay), { once: true });
    }
    window.setTimeout(finish, 4500);
  })();
  } catch(e) { console.error(e); }
})();

})();
